import { Body14Regular } from "@/components/typography/Body14Regular";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Table } from "flowbite-react";
import { ButtonColor } from "../../../common/enum/button-color";
import { StatusButton } from "../../button/StatusButton";
import { CloseOutlineIcon } from "../../icon/CloseOutlineIcon";
import { CustomCell } from "../CustomCell";

interface Props {
  item: ItemDetailDto;
  removeItem: (id: number) => void;
}

export const PackageItemChildSelectTableRow: React.FC<Props> = ({
  item,
  removeItem,
}) => {
  return (
    <Table.Row key={item.id} className="bg-white text-semantic-text-body">
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{item.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <StatusButton color={ButtonColor.CUSTOM_GRAY}>
            {item.isForSale ? "판매중" : "판매 안함"}
          </StatusButton>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <StatusButton color={ButtonColor.CUSTOM_GRAY}>
            {item.isDisplayed ? "진열중" : "진열 안함"}
          </StatusButton>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <CloseOutlineIcon
            onClick={() => {
              removeItem(item.id);
            }}
          />
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
